/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyBillingAddress
 */
export interface CompanyBillingAddress {
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    formattedAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyBillingAddress
     */
    region?: string;
}

/**
 * Check if a given object implements the CompanyBillingAddress interface.
 */
export function instanceOfCompanyBillingAddress(value: object): value is CompanyBillingAddress {
    return true;
}

export function CompanyBillingAddressFromJSON(json: any): CompanyBillingAddress {
    return CompanyBillingAddressFromJSONTyped(json, false);
}

export function CompanyBillingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyBillingAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function CompanyBillingAddressToJSON(value?: CompanyBillingAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'formattedAddress': value['formattedAddress'],
        'region': value['region'],
    };
}

